import React from "react";

type Props = {
  teamOneName?: string;   // e.g., "India"
  teamTwoName?: string;   // e.g., "Pakistan"
  onSelectInning?: (inning: 1 | 2) => void;
};

const BowlingScoreCardModal: React.FC<Props> = ({
  teamOneName = "Team A",
  teamTwoName = "Team B",
  onSelectInning,
}) => {
  return (
    <div className="bowling-score-card-modal">
      <div className="modal-content">
        <div className="inning-options" role="group" aria-label="Select inning">
          <button
            type="button"
            className="inning-card"
            onClick={() => onSelectInning?.(1)}
            aria-label={`Select 1st Inning, Team: ${teamOneName}`}
          >
            <div className="inning-title">1st Inning</div>
            <div className="inning-subtitle">Team: {teamOneName}</div>
          </button>

          <button
            type="button"
            className="inning-card"
            onClick={() => onSelectInning?.(2)}
            aria-label={`Select 2nd Inning, Team: ${teamTwoName}`}
          >
            <div className="inning-title">2nd Inning</div>
            <div className="inning-subtitle">Team: {teamTwoName}</div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default BowlingScoreCardModal;
